angular.module('unica_hotel.hotel_controllers')

.controller('HotelListController', function(
	$rootScope, $scope, $state,
	$confirm,
	HotelListService, HotelDeleteService
) {
	$scope.hotelList = [];
	$scope.limit  = 10;
	$scope.offset = 0;
	$scope.canLoad = true;

	$scope.loadHotels = function() {
		$scope.showLoader();
		$scope.canLoad = false;
		HotelListService
			.list($scope.limit, $scope.offset)
			.then(function(data) {
				$scope.hideLoader();

				if (!data.error) {
					$scope.hotelList = $scope.hotelList.concat( data );
					if ( data.length == 0 ) {
						$scope.canLoad = false;
					} else {
						$scope.canLoad = true;
						$scope.offset = $scope.offset + data.length;
					}
				} else {
					$rootScope.manageError(data);
				}
			});
	};

	$scope.loadHotels();

	$scope.deleteHotel = function(hotelId) {

		$confirm({
			title: 'Sei sicuro di voler eliminare l\'hotel?',
			text: 'Confermi la cancellazione della l\hotel?'
		}).then(function() {

			$scope.showLoader();
			HotelDeleteService
				.delete( hotelId )
				.then(function(data) {
					$scope.hideLoader();

					if (!data.error) {
						angular.forEach($scope.hotelList, function(hotel, key) {
							if ( hotel.id == hotelId ) {
								$scope.hotelList.splice(key, 1);
							}
						});
						$scope.showSuccessMsg('Hotel eliminato con successo!', '');
					} else {
						$rootScope.manageError(data);
					}

				});

		}, function() {
			// Cancel
		});

	};

})

;